import { Alert, AlertDescription } from '@/components/ui/alert'

export default function CombinedResultsNotice() {
  return (
    <Alert
      role="note"
      className="border-amber-500/30 bg-amber-500/10 py-3 text-amber-800 dark:bg-amber-500/10 dark:text-amber-200"
    >
      <AlertDescription>
        Combined results is a provisional feature. We’re continuing to develop and
        improve it over time.
      </AlertDescription>
    </Alert>
  )
}
